import { isFinanceProject, isGlobalProject } from 'config';

export const getLegalClientOtherFormSectionKeys = (): string[] => {
  if (isFinanceProject()) {
    return ['activity', 'businessRelationship', 'debts'];
  }

  if (isGlobalProject()) {
    return [
      'activity',
      'W8BENForm',
      'knowledgeAndExperience',
      'targetedFinancialInstruments',
      'investmentPurposeAndNature',
    ];
  }

  return [];
};
